export const firebaseUatConfig = {
  apiKey: "AIzaSyDUrzUxDgUrTyAEr7osGx4Zt5x8nIrqVRk",
  authDomain: "uat-shubh-loans.firebaseapp.com",
  databaseURL: "https://uat-shubh-loans.firebaseio.com",
  projectId: "uat-shubh-loans",
  storageBucket: "uat-shubh-loans.appspot.com",
  messagingSenderId: "1077214603431",
  appId: "1:1077214603431:web:aab1eec4a92a2029415382",
  measurementId: "G-VV4YRPX5GT",
};

export const firebaseProdConfig = {
  apiKey: "AIzaSyBmOEPV2mydScdNB-1saB3F-KjIUg5FOas",
  authDomain: "shubh-loans.firebaseapp.com",
  databaseURL: "https://shubh-loans.firebaseio.com",
  projectId: "shubh-loans",
  storageBucket: "shubh-loans.appspot.com",
  messagingSenderId: "734320453531",
  appId: "1:734320453531:web:3c72a01af2cb8b507de33e",
  measurementId: "G-LH9RQD7TJX",
};
